<template>
  <div style="margin: 15px; margin-right: 30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="60px">
      <el-form-item label="姓名" prop="userName">
        <el-input v-model.trim="realName" placeholder="请输入姓名" clearable @change="(value)=>{form.userName = value.replace(/\s/g,'')}" />
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input v-model="realPhone" placeholder="请输入电话" clearable />
      </el-form-item>
      <el-form-item label="角色" prop="staffRole">
        <el-input v-model="form.staffRole" disabled placeholder="请输入内容" clearable @clear="clearRole" @focus="selsectRole()" />
        <el-input v-show="false" v-model="form.roleCode" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
    <vxe-modal v-model="role" title="选择角色" width="900" height="800" resize>
      <roleList ref="roleRef" @event="receiveRole" />
    </vxe-modal>
  </div>
</template>
<script>
import { getShipperInfo, updateShipmentStaff } from "@/api/shipment";
import { validatePhone } from "@/utils/validate.js";
import roleList from "./components/roleList";
export default {
  name: "ShipmentStaffEdit",
  components: {
    roleList,
  },
  props: {
    staffTypeOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    companyCode: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      realName:"",
      realPhone:"",
      role: false,
      form: {},
      rules: {
        userName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符" },
        ],
        phone: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("手机号格式有误"));
            },
            trigger: "blur",
          },
        ],
        staffRole: [
          { required: true, message: "请选择角色", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    clearRole() {
      this.form.staffRole = "";
      this.form.roleCode = "";
    },
    // 选择角色
    selsectRole() {
      this.$refs.roleRef.findList(this.form);
      this.role = true;
    },
    receiveRole(data) {
      this.role = false;
      this.$set(this.form, "staffRole", data.roleName);
      this.form.roleCode = data.code;
      this.form.shipmentRoleType = data.role;
      let shipmentRoleType = this.staffTypeOptions.find((item) => data.role == item.role) || [];
      this.form.ApiModelProperty = shipmentRoleType.role || 10;
    },
    // 获取 详情
    getInfo(code) {
      getShipperInfo(code).then((response) => {
        let data = response.data;
        this.form = data;
        this.realName = data.subUserName || data.userName;
        this.realPhone = data.subPhone || data.phone;
      });
    },
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          this.form.userName = this.realName;
          this.form.phone = this.realPhone;
          updateShipmentStaff(this.form)
            .then((response) => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherEditMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}


</style>
